import server from '../request';

import encryptServer from '../request/encryptRequest';

// 合同列表(分页)
export const queryPage = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/contract/queryPage', data);
};

// 统计 采购合同 状态信息
export const queryStateInfo = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/contract/queryStateInfo', data);
};

// 查询合同(根据合同ID)
export const queryDetail = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/contract/queryById', data);
};

// 分页查询操作日志
export const queryLogListById = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/seller/queryLogListById', data);
};

// 合同变更审核
export const editCheckState = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/contract/editCheckStateById', data);
};

// 合同审核
export const editContractState = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/contract/editContractStateById', data);
};

// 供应商详情
export const customerDetail = (data = {}) => {
  return server.post('/xiaozi-xms/wireless/saas/customer/detail', data);
};

// 供应商详情

export const supplierDetail = (data = {}) => {
  return encryptServer.post('/xiaozi-xmo/wireless/saas/xz/erp/supplier/detail', data);
};

// 物资信息 分页列表(根据协议 || 合同 ID)
export const queryMaterialList = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/contract/queryMaterialList', data);
};

// 获取核算单位详情

export const detailAccountingUnit = (data = {}) => {
  return encryptServer.post('/xiaozi-xmo/wireless/saas/xz/erp/accountingUnit/detail', data);
};

// 销售合同导出
export const exportSaleContract = (params) => {
  return server.post('/xiaozi-xms/wireless/saas/contract/exportContractItem', params, {
    responseType: 'blob',
  });
};
